export default __webpack_public_path__ + "static/media/e.d00e8157.mp4";